function GameProduct() {
  this.currency_amount = "";
  this.currency_code = "";
  this.out_trade_no = "";
  this.product_id = "";
  this.product_name = "";
  this.product_count = "";
  this.request_url = "";
  this.cash_back = "";
}

GameProduct.prototype = {
  constructor: GameProduct
};

export default GameProduct;



// WEBPACK FOOTER //
// ./src/common/js/model/GameProduct.js